import React, { useEffect, useState } from "react";

import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/style.scss';
import '../style/style.css';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery,ButtonBase,Avatar,Drawer,List,ListItem,ListItemIcon,ListItemText,Divider,Chip ,Collapse,ListItemButton} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from "../utils";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import {Settings,AssignmentTurnedIn,ExpandLess,ExpandMore,HealthAndSafety,Vaccines,MedicalServices,Looks3,Business} from '@mui/icons-material';

const drawerWidth = 240;

const pages = [{pagina:"Clienti",percorso:"Clienti",icon:<Business />},{pagina:"Checklist",percorso:"Checkhomepage",icon:<AssignmentTurnedIn />}]
const pMedicina = [{pagina:"Medici",percorso:"Medici",icon:<MedicalServices/>},{pagina:"Visite Mediche",percorso:"VisiteMediche",icon:<Vaccines />},{pagina:"Allegato 3B",percorso:"Allegato3b",icon:<Looks3 />}]

const Header = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const navigate = useNavigate();
  const [open,setOpen]=useState(false);
  const [oCollapse,setOCollapse] = useState({medicina:false,anagrafiche:false})
const toggleDrawer = (val) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setOpen(!val);
  };
function myLogout(){
logout();
navigate('/login');
}

const handleClick = (tipo) => {

let oc = {...oCollapse};
oc[tipo] = !oc[tipo];

setOCollapse(oc);


}




//style={{backgroundColor:"#2264ae"}}
  return (
    <>
    <Box sx={{ display: 'flex' }}>
    <CssBaseline />
    {/* header */}
    <AppBar
        enableColorOnDark
    
        color="inherit"
        elevation={0}
        position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
        <Toolbar>
        <Box
                sx={{
                    width: 228,
                    display: 'flex'
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                <ButtonBase disableRipple onClick={() => navigate("/")}>
    <img src={Logo} style={{height:"40px",marginTop:"5px"}} ></img>
    </ButtonBase>
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}  onClick={toggleDrawer(open)}>
                    <Avatar 
                   
                    sx={{backgroundColor:"#fff",color:"#2264ae"}}
                        variant="rounded"
                        color="inherit"
                    >
                        <i class="bi bi-list"></i>
                    </Avatar>

                </ButtonBase>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: "#2264ae",
                    backgroundColor: "#2264ae",
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: "#67afff",
                        background: "#67afff!important",
                        color:"#67afff"
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                    sx={{
                      width: '34px',
                      height: '34px',
                      fontSize: '1.2rem',
                      margin: '8px 0 8px 8px !important',
                      cursor: 'pointer'
                  }}
                      src={localStorage.getItem('fotoProfilo')}
                        aria-haspopup="true"
                        color="inherit"

                    />
                }
                
                label={<Settings stroke={1.5} style={{height:"1.5rem",width:"1.5rem",color:"white"}} color="white" />}
                variant="outlined"
            
                aria-haspopup="true"

                color="primary"
            />
        </Toolbar>
    </AppBar>
    </Box>
  
          <Drawer
             variant={window.innerWidth<926?"temporary":"persistent"}
            open={open}
            onClose={() => setOpen(false)}
            ModalProps={{ keepMounted: true }}
            
            sx={open?{width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box',border:"none" },
                  }:""}
          >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }} >
            <List>
          {pages.map((page, index) => (
            <ListItem button key={page.pagina} onClick={() =>{navigate("/"+page.percorso);setOpen(false);  }}>
               <ListItemIcon>
          {page.icon}
        </ListItemIcon>
              <ListItemText primary={page.pagina} />
            </ListItem>
          ))}


        <ListItemButton onClick={() => handleClick("medicina")} >
        <ListItemIcon>
        <HealthAndSafety sx={{color:oCollapse.medicina?"red":""}}/>
        </ListItemIcon>
        <ListItemText primary="Medicina" sx={{fontWeight:"bold"}} />
        {oCollapse.medicina ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
            <Collapse in={oCollapse.medicina} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
        {pMedicina.map((page, index) => (
            <ListItem button key={page.pagina} onClick={() =>{navigate("/"+page.percorso);setOpen(false);  }}>
               <ListItemIcon>
          {page.icon}
        </ListItemIcon>
              <ListItemText primary={page.pagina} />
            </ListItem>
          ))}
        </List>
      </Collapse>


        </List>
            </Box>
          </Drawer>
      
          </>
  )
}











export default Header;

